/*
Svg Sprites

markup:
<svg class="some-class-name"
     role="img"
     aria-hidden="true"
     focusable="false">
    <title id="{{modifier_class}}">{{modifier_class}}</title>
    <desc id="{{modifier_class}}">{{modifier_class}}</desc>
  	<use xmlns:xlink="http://www.w3.org/1999/xlink"
         xlink:href="{{ asseturl '/static/theme/images/sprites.svg' }}#{{modifier_class}}"></use>
</svg>

title-playtowin - title-playtowin
character_creative - character_creative
character_strategy - character_strategy
character_technology - character_technology
character_you - character_you
character-clientservices - character-clientservices
character-operations - character-operations
episerver-logo - episerver-logo
fusion-logo - fusion-logo
icon_calendar - icon_calendar
icon_developers - icon_developers
icon_mail - icon_mail
icon_network - icon_network
icon_pencil - icon_pencil
icon_people - icon_people
icon_web_page - icon_web_page
icon-awardwinning - icon-awardwinning
icon-blog - icon-blog
icon-casestudies - icon-casestudies
icon-clientleader - icon-clientleader
icon-cog - icon-cog
icon-design - icon-design
icon-designer - icon-designer
icon-developer - icon-developer
icon-deviceagnostic - icon-deviceagnostic
icon-easyintegration - icon-easyintegration
icon-efficient - icon-efficient
icon-engaging - icon-engaging
icon-error - icon-error
icon-fast - icon-fast
icon-mobilepayments - icon-mobilepayments
icon-nativeapps - icon-nativeapps
icon-news - icon-news
icon-personalised - icon-personalised
icon-secure - icon-secure
icon-seo - icon-seo
icon-simple - icon-simple
icon-speed - icon-speed
icon-strategist - icon-strategist
icon-strategy - icon-strategy
icon-tech - icon-tech
icon-vr - icon-vr
icon-you - icon-you
play - play
quotemark - quotemark
related-blog - related-blog
related-news - related-news
related-work - related-work
services-creative - services-creative
services-operations - services-operations
services-strategy - services-strategy
services-technology - services-technology


Styleguide FUS078.Sprites
*/

// this hack requires all svgs in the current directory
// causing webpacks svg sprite loader to kick into action.
const files = require.context(__dirname, true, /\.svg$/);
files.keys().forEach(files);

import "./icons__config";



// WEBPACK FOOTER //
// ./client/src/site__fus078/icons/index.js